import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { map } from 'rxjs';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { SV_USER_ROLE, SV_PROPOSAL_STATUS, SV_USER, PROPOSAL_ID, IFCConcurred, IFCDeclined, IFCPending, ConfirmationHeading, ConfirmationContent, STATUSPendingGovernance, IFCSecretaryGroupName, TAB_TITLE_DEFAULT_CLASS, LocalComptrollersGroupName, LocalLegalGroupName, LocalTaxGroupName, LocalTreasuryGroupName,LocalBUGroupName,LocalOthersGroupName, STATUSPendingLocalIFCConcurrence, LOCALLEGAL, LOCALCOMPTROLLERS, LOCALTAX, LOCALTREASURY, STATUSPendingIFCConcurrence, LOCALBU, LOCALOTHERS, LocalReviewerRequired, LocalReviewerDueDateRequired } from 'src/app/constants/constants';
//import { IFCReviewersMembersDTO, IFCGroupsDTO } from 'src/app/core/interfaces/ifcReviewers';
import { LocalIFCBUReviewer, LocalIFCControllersReviewer, LocalIFCGroupsDTO, LocalIFCLegalReviewer, LocalIFCOthersReviewer, LocalIFCReviewer, LocalIFCReviewersMembersDTO, LocalIFCTaxReviewer, LocalIFCTreasuryReviewer } from 'src/app/core/interfaces/LocalIFCReviewer';
import { UserDetails } from 'src/app/core/interfaces/User';
//import { IFCGroupsDTO, IFCReviewersMembersDTO } from 'src/app/core/interfaces/ifcReviewers';
import { P30APIService } from 'src/app/core/services/api';
import { DataService } from 'src/app/core/services/data_service';
import { DataServiceApprovals } from 'src/app/core/services/data_service_approvals';
import { DataServiceIFCReviewers } from 'src/app/core/services/data_service_ifc_reviewers';
import { MsGraphService } from 'src/app/core/services/ms-graph';
import { SessionStorageService } from 'src/app/core/services/session_storage';

@Component({
    selector: 'app-local-reviewer',
    templateUrl: './local-reviewer.component.html',
    styleUrl: './local-reviewer.component.less',
    animations: [formControlElement, formLabelElement],
    standalone: false
})
export class LocalReviewerComponent implements OnInit {
  @Output() localPayloadRecords = new EventEmitter<LocalIFCGroupsDTO[]>();
  @Output() isLocalApprovalSubmitted = new EventEmitter<boolean>();
  @Output() isResetEmailTrigger = new EventEmitter<boolean>();
  @Output() isReminderEmailTrigger = new EventEmitter<boolean>();
  @Output() isLoader = new EventEmitter<boolean>();
  @Output() localRevewerTabClass = new EventEmitter<string>();
  @Input() isIFCRequired!: boolean;
  @Input() reviewComponent!: boolean | string;
  localLegalDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  localControllersDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  localTaxDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  localTreasuryDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  localBUDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  localOthersDefaultMember: LocalIFCReviewersMembersDTO[] = [];
  //localGovernanceDefaultMember: IFCReviewersMembersDTO[] = [];
  //localSecretaryDefaultMember: IFCReviewersMembersDTO[] = [];
  userRoleTitle: any;
  isDueDate!: string | null;
  isConcurDate!: string;
  legalConcurrence!: string;
  controllersConcurrence!: string;
  taxConcurrence!: string;
  treasuryConcurrence!: string;
  buConcurrence!: string;
  othersConcurrence!: string;
  governanceConcurrence!: string;
  proposalStatus!: string;
  loggedInUserID!: number;
  listOfGroupsMemberByDefault: LocalIFCReviewersMembersDTO[] = [];
  approvalsRecords: LocalIFCGroupsDTO[] = [];
  proposal_ID: string = this.session.getItem(PROPOSAL_ID);
  approverId = this.session.getItem(SV_USER).userId;
  isVisible!: boolean;
  isOkLoading!: boolean;
  isModalYesBtnClicked!: boolean;
  isModalNoBtnClicked!: boolean;
  confirmModal?: any;
  confirmationModalHeading = ConfirmationHeading;
  confirmationModalContent = ConfirmationContent;
  showHideLIFCModal: boolean = false;
  resetGroupName!: string;
  legalStatus!: boolean | null;
  controllersStatus!: boolean | null;
  taxStatus!: boolean | null;
  treasuryStatus!: boolean | null;
  governanceStatus!: boolean | null;
  localLegalApprovalsId!: number | null;
  localTaxApprovalsId!: number | null;
  localControllersApprovalsId!: number | null;
  localTresuryApprovalsId!: number | null;
  localBUApprovalsId!: number | null;
  localOthersApprovalsId!: number | null;
  localGovernanceApprovalsId!: number | null;
  legalConcuredStatus!: boolean | null;
  controllersConcuredStatus!: boolean | null;
  taxConcuredStatus!: boolean | null;
  treasuryConcuredStatus!: boolean | null;
  buConcuredStatus!: boolean | null;
  othersConcuredStatus!: boolean | null;
  governanceConcuredStatus!: boolean | null;
  sessionDueDate: any;
  isActionComplete!: boolean;
  reviewerCommet!: string;
  isLocalReviewer!: boolean;
  localReviewerErrorMsg: string = '';

  coordianatorLocalForm!: UntypedFormGroup;
  coordianatorLocalFormModel: LocalIFCReviewer = {
    dueDate: '',
    concurDate: '',
    localTreasury: [],
    localLegal: [],
    localControllers: [],
    localTax: [],
    localBU: [],
    localOthers: []
  };

  localSecretaryForm!: UntypedFormGroup;
  localSecretaryFormModel = {
    dueDate: '',
    concurDate: '',
    //localSecretary: '',
  };
  localLegalForm!: UntypedFormGroup;
  localLegalFormModel: LocalIFCLegalReviewer = {
    localLegal: [],
    legalComments: '',
    localLegalSwitch: false,
  };
  localControllersForm!: UntypedFormGroup;
  localControllersFormModel: LocalIFCControllersReviewer = {
    localControllers: [],
    controllersComments: '',
    localControllersSwitch: false,
  };
  localTaxForm!: UntypedFormGroup;
  localTaxFormModel: LocalIFCTaxReviewer = {
    localTax: [],
    taxComments: '',
    localTaxSwitch: false,
  };
  localTreasuryForm!: UntypedFormGroup;
  localTreasuryFormModel: LocalIFCTreasuryReviewer = {
    localTreasury: [],
    treasuryComments: '',
    localTreasurySwitch: false,
  };
  localBUForm!: UntypedFormGroup;
  localBUFormModel: LocalIFCBUReviewer = {
    localBU: [],
    buComments: '',
    localBUSwitch: false,
  };
  localOthersForm!: UntypedFormGroup;
  localOthersFormModel: LocalIFCOthersReviewer = {
    localOthers: [],
    othersComments: '',
    localOthersSwitch: false,
  };
  // localGovernanceForm!: UntypedFormGroup;
  // localGovernanceFormModel = {
  //   localGovernance: '',
  //   governanceComments: '',
  //   localGovernanceSwitch: false,
  // };

  constructor(
    private fb: UntypedFormBuilder,
    private dataservice: DataService,
    private session: SessionStorageService,
    private graph: MsGraphService,
    private localReviewersService: DataServiceIFCReviewers
  ) {
   }

   saveReviewerComments(event:string) {
    
    this.session.setItem("reviewerCommnets",event);
    //this.messageEvent.emit(event);
  }
  async ngOnInit() {
    const regex = new RegExp('Reviewer');
    //this.createFormGroupsWithNestedFormControllers();
    this.isLocalReviewer = regex.test(this.session?.getItem(SV_USER_ROLE).roleTitle);
    this.isActionComplete = false;
    this.loggedInUserID = this.session.getItem(SV_USER).userId;
    this.dataservice.getUserRoleTitle(this.session.getItem(SV_USER_ROLE).roleTitle);
    this.proposalStatus = this.session.getItem(SV_PROPOSAL_STATUS).name.toLocaleLowerCase();
    this.userRoleTitle = this.dataservice.roleTitle.toLocaleLowerCase();
    this.sessionDueDate =  null; 
    this.localReviewersService.reviewNsubmitStatus(undefined);
    //this.localReviewersService.getIFCUpdateRecordsStatus(undefined);
    this.localReviewersService.getLocalUpdateRecordsStatus(undefined);
    if (this.isIFCRequired) {
      this.createFormGroupsWithNestedFormControllers();
      await this.getDefaultMemberOfGroups();
      await this.getApprovalsList();
      if(!this.reviewComponent)
      this.enableDisableCommentsFormFields();
    }
    this.showHideLIFCModal = false;
    this.createPayload();
    this.selectDueByDate(this.localSecretaryFormModel.dueDate);
    this.localReviewersService.errorMsg$.subscribe(msg => {
      this.localReviewerErrorMsg = msg=== "LOCAL_REVIEWER_ERROR" ? LocalReviewerRequired : (msg === "DUE_DATE_ERROR" ? LocalReviewerDueDateRequired : msg);
    });
  }

  // to get default members of all groups
  async getDefaultMemberOfGroups() {
    this.isLoader.emit(true);
    this.listOfGroupsMemberByDefault = [];
    let defaultUser = await this.localReviewersService.defaultLocalGroupMemberAPICall();
    defaultUser.subscribe({
      next: (groupMember) => {
        if (groupMember['body']) {
          this.listOfGroupsMemberByDefault = [...groupMember['body']];
          this.listOfGroupsMemberByDefault = this.listOfGroupsMemberByDefault.filter(x => x.defaultEmail == '');
          this.storeDefaultMemberIntoVariable();
          this.isLoader.emit(false);
        }
      },
      error: (err) => {
        console.log("default members error => ", err);
      },
      complete: () => {
        this.isLoader.emit(false);
      }
    })
  }

  // to get all records of approval
  async getApprovalsList() {
    this.isLoader.emit(true);
    let approvalsRecords = await this.localReviewersService.getLocalApprovals();
    approvalsRecords.subscribe({
      next: (approvals) => {
        let localIfcApprovals: LocalIFCGroupsDTO[] = [];
        localIfcApprovals = approvals['body'];
        localIfcApprovals = localIfcApprovals?.filter(x => (x.type.toString().toLocaleLowerCase() == LocalLegalGroupName || x.type.toString().toLocaleLowerCase() == LocalComptrollersGroupName || x.type.toString().toLocaleLowerCase() == LocalTaxGroupName || x.type.toString().toLocaleLowerCase() == LocalTreasuryGroupName || x.type.toString().toLocaleLowerCase() == LocalBUGroupName|| x.type.toString().toLocaleLowerCase() == LocalOthersGroupName ));
        if (localIfcApprovals) {
          this.isLoader.emit(false);
          this.setDefaultSecretary();
          this.reviewComponentUIShowHideData(localIfcApprovals);
          if (localIfcApprovals[0]?.dueDate) {
            this.isLocalApprovalSubmitted.emit(true);
            this.localReviewersService.getLocalUpdateRecordsStatus(true);
            this.isDueDate = localIfcApprovals[0]?.dueDate;
            this.localSecretaryForm?.controls['dueDate'].setValue(localIfcApprovals[0]?.dueDate);
            this.localSecretaryForm?.updateValueAndValidity();
            this.isActionComplete = true;
            this.localRevewerTabClass.emit(TAB_TITLE_DEFAULT_CLASS);
          }
          for (let approval of localIfcApprovals) {
            if(this.session.getItem(SV_USER_ROLE).roleTitle == approval.type){
              this.reviewerCommet = approval.comment;
              this.session.setItem("reviewerCommnets",this.reviewerCommet)
            }
            this.setUpdateLocalIFCFormFieldsValue(approval);
          }
          this.createPayload();
          this.setResetDueDateFormValidation();
        } else {
          this.isActionComplete = true;
          this.isDueDate = null;
          this.isLocalApprovalSubmitted.emit(false);
          this.localReviewersService.getLocalUpdateRecordsStatus(false);
          this.storeDefaultMemberIntoVariable();
          this.setResetDueDateFormValidation();
        }
      },
      error: (err) => {
        console.log("approvals records error => ", err);
      },
      complete: () => {
        this.showHideLIFCModal=false;
        this.isLoader.emit(false);
      }
    })
  }

  // to set default secretary group member
  setDefaultSecretary() {
    let defaultSecretary = this.listOfGroupsMemberByDefault.find((ele: any) => {
      return ele['type'].toLocaleLowerCase() == IFCSecretaryGroupName;
    })
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        //this.coordianatorLocalForm?.controls['localSecretary'].setValue(defaultSecretary?.defaultEmail);
        this.coordianatorLocalFormModel.localTreasury = <any>defaultSecretary?.defaultEmail;
        break;
      }
      // case STATUSPendingLocalIFCConcurrence: {
      //   this.localSecretaryForm?.controls['localSecretary'].setValue(defaultSecretary?.defaultEmail);
      //   this.localSecretaryFormModel.localSecretary = <any>defaultSecretary?.defaultEmail;
      //   break;
      // }
      case 'default': {
        break;
      }
    }
  }

  setUpdateLocalIFCFormFieldsValue(approvalRecords: LocalIFCGroupsDTO) {
    if (this.proposalStatus == STATUSPendingGovernance) {
      this.setPendingGoverenceFormValues(approvalRecords);
    } else if (this.proposalStatus == STATUSPendingIFCConcurrence || this.proposalStatus == STATUSPendingLocalIFCConcurrence) {
      this.setLocalIFCConcurrenceFormValues(approvalRecords);
    }
  }

  setPendingGoverenceFormValues(approvalRecords: LocalIFCGroupsDTO) {
    const due = this.sessionDueDate ? this.sessionDueDate : null;
    const dueDate = this.isDueDate ? this.isDueDate : due;
    if (this.proposalStatus == STATUSPendingGovernance) {
      this.coordianatorLocalForm?.controls['dueDate'].setValue(dueDate);
      this.coordianatorLocalFormModel.dueDate = dueDate;
      this.coordianatorLocalForm?.controls['concurDate'].setValue(this.isConcurDate);
      this.coordianatorLocalFormModel.concurDate = this.isConcurDate;
      switch (approvalRecords.type.toLocaleLowerCase()) {
        case LocalLegalGroupName: {
          //this.coordianatorLocalForm?.controls['localLegal'].setValue(approvalRecords['approverEmail']);
          //this.coordianatorLocalFormModel.localLegal.push(approvalRecords['approverEmail']);
          let legalEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localLegalDefaultMember = [];
          for (let email of legalEmails) {
            if (email != '') {
              this.localLegalDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              })
            }
          }
          if (this.localLegalDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localLegal = legalEmails;
            const control = this.coordianatorLocalForm.controls["localLegal"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localLegalApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case LocalComptrollersGroupName: {
          //this.coordianatorLocalForm?.controls['localControllers'].setValue(approvalRecords['approverEmail']);
          //this.coordianatorLocalFormModel.localControllers = approvalRecords['approverEmail'];
          let controllersEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localControllersDefaultMember = [];
          for (let email of controllersEmails) {
            if (email != '') {
              this.localControllersDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              });
            }
          }
          if (this.localControllersDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localControllers = controllersEmails;
            const control = this.coordianatorLocalForm.controls["localControllers"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localControllersApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case LocalTaxGroupName: {
          //this.coordianatorLocalForm?.controls['localTax'].setValue(approvalRecords['approverEmail']);
          //this.coordianatorLocalFormModel.localTax = approvalRecords['approverEmail'];
          let taxEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localTaxDefaultMember = [];
          for (let email of taxEmails) {
            if (email != '') {
              this.localTaxDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              });
            }
          }
          if (this.localTaxDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localTax = taxEmails;
            const control = this.coordianatorLocalForm.controls["localTax"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localTaxApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case LocalTreasuryGroupName: {
          //this.coordianatorLocalForm?.controls['localTreasury'].setValue(approvalRecords['approverEmail']);
          //this.coordianatorLocalFormModel.localTreasury = approvalRecords['approverEmail'];
          let treasuryEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localTreasuryDefaultMember = [];
          for (let email of treasuryEmails) {
            if (email != '') {
              this.localTreasuryDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              });
            }
          }
          if (this.localTreasuryDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localTreasury = treasuryEmails;
            const control = this.coordianatorLocalForm.controls["localTreasury"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localTresuryApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case LocalBUGroupName: {
          let buEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localBUDefaultMember = [];
          for (let email of buEmails) {
            if (email != '') {
              this.localBUDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              });
            }
          }
          if (this.localBUDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localBU = buEmails;
            const control = this.coordianatorLocalForm.controls["localBU"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localBUApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case LocalOthersGroupName: {
          let othersEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
          this.localOthersDefaultMember = [];
          for (let email of othersEmails) {
            if (email != '') {
              this.localOthersDefaultMember.push({
                defaultEmail: email,
                reviewerId: approvalRecords['reviewerId'],
                type: approvalRecords['type']
              });
            }
          }
          if (this.localOthersDefaultMember.length > 0) {
            this.coordianatorLocalFormModel.localOthers = othersEmails;
            const control = this.coordianatorLocalForm.controls["localOthers"];
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
          this.localOthersApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        
        case 'default': {
          break;
        }
      }
      this.coordianatorLocalForm?.updateValueAndValidity();
    }
  }

  setLocalIFCConcurrenceFormValues(approvalRecords: LocalIFCGroupsDTO) {
    let status = approvalRecords['status'] === false ? IFCDeclined : IFCPending;
    switch (approvalRecords.type.toLocaleLowerCase()) {
      case LocalLegalGroupName: {
        let legalEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localLegalDefaultMember = [];
        this.localLegalForm?.setValue({
          localLegal: legalEmails,
          legalComments: approvalRecords['comment'],
          localLegalSwitch: approvalRecords['reset'],
        });
        this.localLegalForm?.updateValueAndValidity();
        for (let email of legalEmails) {
          if (email != '') {
            this.localLegalDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localLegalApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localLegalFormModel.localLegal.push(approvalRecords['approverEmail']);
        this.localLegalFormModel.localLegal = legalEmails;
        this.localLegalFormModel.legalComments = approvalRecords['comment'];
        this.localLegalFormModel.localLegalSwitch = <any>approvalRecords['reset'];
        this.legalConcuredStatus = approvalRecords['status'];
        this.legalConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.legalConcurrence !== IFCConcurred) this.localLegalForm?.controls['localLegalSwitch'].disable();
        break;
      }
      case LocalComptrollersGroupName: {
        let controllersEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localControllersDefaultMember = [];
        this.localControllersForm.setValue({
          localControllers: controllersEmails,
          controllersComments: approvalRecords['comment'],
          localControllersSwitch: approvalRecords['reset'],
        });
        this.localControllersForm?.updateValueAndValidity();
        for (let email of controllersEmails) {
          if (email != '') {
            this.localControllersDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localControllersApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localControllersFormModel.localControllers.push(approvalRecords['approverEmail']);
        this.localControllersFormModel.localControllers = controllersEmails;
        this.controllersConcuredStatus = approvalRecords['status'];
        this.controllersConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.controllersConcurrence !== IFCConcurred) this.localControllersForm?.controls['localControllersSwitch'].disable();
        break;
      }
      case LocalTaxGroupName: {
        let taxEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localTaxDefaultMember = [];
        this.localTaxForm.setValue({
          localTax: taxEmails,
          taxComments: approvalRecords['comment'],
          localTaxSwitch: approvalRecords['reset'],
        });
        this.localTaxForm?.updateValueAndValidity();
        for (let email of taxEmails) {
          if (email != '') {
            this.localTaxDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localTaxApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localTaxFormModel.localTax.push(approvalRecords['approverEmail']);
        this.localTaxFormModel.localTax = taxEmails;
        this.taxConcuredStatus = approvalRecords['status'];
        this.taxConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.taxConcurrence !== IFCConcurred) this.localTaxForm?.controls['localTaxSwitch'].disable();
        break;
      }
      case LocalTreasuryGroupName: {
        let treasuryEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localTreasuryDefaultMember = []
        this.localTreasuryForm.setValue({
          localTreasury: treasuryEmails,
          treasuryComments: approvalRecords['comment'],
          localTreasurySwitch: approvalRecords['reset'],
        });
        this.localTreasuryForm?.updateValueAndValidity();
        for (let email of treasuryEmails) {
          if (email != '') {
            this.localTreasuryDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localTresuryApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localTreasuryFormModel.localTreasury.push(approvalRecords['approverEmail']);
        this.localTreasuryFormModel.localTreasury = treasuryEmails;
        this.treasuryConcuredStatus = approvalRecords['status'];
        this.treasuryConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.treasuryConcurrence !== IFCConcurred) this.localTreasuryForm?.controls['localTreasurySwitch'].disable();
        break;
      }

      case LocalBUGroupName: {
        let buEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localBUDefaultMember = []
        this.localBUForm.setValue({
          localBU: buEmails,
          buComments: approvalRecords['comment'],
          localBUSwitch: approvalRecords['reset'],
        });
        this.localBUForm?.updateValueAndValidity();
        for (let email of buEmails) {
          if (email != '') {
            this.localBUDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localBUApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localTreasuryFormModel.localTreasury.push(approvalRecords['approverEmail']);
        this.localBUFormModel.localBU = buEmails;
        this.buConcuredStatus = approvalRecords['status'];
        this.buConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.buConcurrence !== IFCConcurred) this.localBUForm?.controls['localBUSwitch'].disable();
        break;
      }

      case LocalOthersGroupName: {
        let othersEmails = approvalRecords['approverEmail'].includes(';') ? approvalRecords['approverEmail'].split(';') : [approvalRecords['approverEmail']];
        this.localOthersDefaultMember = []
        this.localOthersForm.setValue({
          localOthers: othersEmails,
          othersComments: approvalRecords['comment'],
          localOthersSwitch: approvalRecords['reset'],
        });
        this.localOthersForm?.updateValueAndValidity();
        for (let email of othersEmails) {
          if (email != '') {
            this.localOthersDefaultMember.push({
              defaultEmail: email,
              reviewerId: approvalRecords['reviewerId'],
              type: approvalRecords['type']
            });
          }
        };
        this.localOthersApprovalsId = <any>approvalRecords['approvalsId'];
        //this.localTreasuryFormModel.localTreasury.push(approvalRecords['approverEmail']);
        this.localOthersFormModel.localOthers = othersEmails;
        this.othersConcuredStatus = approvalRecords['status'];
        this.othersConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.othersConcurrence !== IFCConcurred) this.localOthersForm?.controls['localOthersSwitch'].disable();
        break;
      }
      
      case IFCSecretaryGroupName: {
        this.localSecretaryForm.setValue({
          dueDate: approvalRecords['dueDate'],
          concurDate: approvalRecords['concurDate'],
          localSecretary: approvalRecords['approverEmail'],
        });
        break;
      }
    }
  }

  enableDisableCommentsFormFields() {
    if ((this.proposalStatus == STATUSPendingIFCConcurrence) || (this.proposalStatus == STATUSPendingLocalIFCConcurrence)) {
      this.localLegalForm.controls['legalComments'].disable();
      this.localLegalForm.controls['localLegal'].disable();
      this.localControllersForm.controls['controllersComments'].disable();
      this.localControllersForm.controls['localControllers'].disable();
      this.localTaxForm.controls['taxComments'].disable();
      this.localTaxForm.controls['localTax'].disable();
      this.localTreasuryForm.controls['treasuryComments'].disable();
      this.localTreasuryForm.controls['localTreasury'].disable();
      this.localBUForm.controls['localBU'].disable();
      this.localOthersForm.controls['localOthers'].disable();
      // this.localGovernanceForm.controls['governanceComments'].disable();
      // this.localGovernanceForm.controls['localGovernance'].disable();
      // this.localSecretaryForm.controls['localSecretary'].disable();
    }
  }

  createFormGroupsWithNestedFormControllers1() {
    if ((this.proposalStatus == 'pending ifc concurrence') || (this.proposalStatus == 'pending local ifc concurrence')) {
      this.localSecretaryForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        //localSecretary: [null],
      });
      this.localLegalForm = this.fb.group({
        localLegal: [null],
        legalComments: [null],
        localLegalSwitch: [false],
      });
      this.localControllersForm = this.fb.group({
        localControllers: [null],
        controllersComments: [null],
        localControllersSwitch: [false],
      });
      this.localTaxForm = this.fb.group({
        localTax: [null],
        taxComments: [null],
        localTaxSwitch: [false],
      });
      this.localTreasuryForm = this.fb.group({
        localTreasury: [null],
        treasuryComments: [null],
        localTreasurySwitch: [false],
      });
      this.localBUForm = this.fb.group({
        localBU: [null],
        buComments: [null],
        localBUSwitch: [false],
      });
      this.localOthersForm = this.fb.group({
        localOthers: [null],
        othersComments: [null],
        localOthersSwitch: [false],
      });
      // this.localGovernanceForm = this.fb.group({
      //   localGovernance: [null],
      //   governanceComments: [null],
      //   localGovernanceSwitch: [false],
      // });
    } else {
      this.coordianatorLocalForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        //localSecretary: [null],
        localLegal: [null],
        localControllers: [null],
        localTax: [null],
        localTreasury: [null],
        localBU: [null],
        localOthers: [null]
        //localGovernance: [null],
      });
    }
  }

  createFormGroupsWithNestedFormControllers() {
    
    if ((this.proposalStatus == 'pending ifc concurrence') || (this.proposalStatus == 'pending reviewer(s) concurrence')) {
      this.localSecretaryForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        //localSecretary: [null],
      });
      this.localLegalForm = this.fb.group({
        localLegal: [null],
        legalComments: [null],
        localLegalSwitch: [false],
      });
      this.localControllersForm = this.fb.group({
        localControllers: [null],
        controllersComments: [null],
        localControllersSwitch: [false],
      });
      this.localTaxForm = this.fb.group({
        localTax: [null],
        taxComments: [null],
        localTaxSwitch: [false],
      });
      this.localTreasuryForm = this.fb.group({
        localTreasury: [null],
        treasuryComments: [null],
        localTreasurySwitch: [false],
      });
      this.localBUForm = this.fb.group({
        localBU: [null],
        buComments: [null],
        localBUSwitch: [false],
      });
      this.localOthersForm = this.fb.group({
        localOthers: [null],
        othersComments: [null],
        localOthersSwitch: [false],
      });
      // this.localGovernanceForm = this.fb.group({
      //   localGovernance: [null],
      //   governanceComments: [null],
      //   localGovernanceSwitch: [false],
      // });
    } else {
      this.coordianatorLocalForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        //localSecretary: [null],
        localLegal: [null],
        localControllers: [null],
        localTax: [null],
        localTreasury: [null],
        localBU: [null],
        localOthers: [null]
        //localGovernance: [null],
      });
    }
  }


  async storeDefaultMemberIntoVariable() {
    const dueDate = this.isDueDate ? this.isDueDate : this.sessionDueDate;
    this.coordianatorLocalForm?.controls['dueDate'].setValue(dueDate);
    if (this.listOfGroupsMemberByDefault) {
      this.listOfGroupsMemberByDefault.forEach(
        (member: LocalIFCReviewersMembersDTO) => {
          switch (member['type'].toLocaleLowerCase()) {
            case 'reviewer legal': {
              let legalEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localLegalDefaultMember = [];
              for (let email of legalEmails) {
                if (email != '') {
                  this.localLegalDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              if (this.localLegalDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localLegal = legalEmails;
                const control = this.coordianatorLocalForm.controls["localLegal"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }
            case 'reviewer finance': {
              let comptrollersEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localControllersDefaultMember = [];
              for (let email of comptrollersEmails) {
                if (email != '') {
                  this.localControllersDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              //this.coordianatorLocalForm?.controls['localControllers'].setValue(member['defaultEmail']);
              //this.coordianatorLocalFormModel.localControllers.push(member['defaultEmail']);
              if (this.localControllersDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localControllers = comptrollersEmails;
                const control = this.coordianatorLocalForm.controls["localControllers"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }
            case 'reviewer tax': {
              let taxEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localTaxDefaultMember = [];
              for (let email of taxEmails) {
                if (email != '') {
                  this.localTaxDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              //this.coordianatorLocalForm?.controls['localTax'].setValue(member['defaultEmail']);
              //this.coordianatorLocalFormModel.localTax=member['defaultEmail'];
              if (this.localTaxDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localTax = taxEmails;
                const control = this.coordianatorLocalForm.controls["localTax"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }
            case 'reviewer treasury': {
              let treasuryEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localTreasuryDefaultMember = [];
              for (let email of treasuryEmails) {
                if (email != '') {
                  this.localTreasuryDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              //this.coordianatorLocalForm?.controls['localTreasury'].setValue(member['defaultEmail']);
              //this.coordianatorLocalFormModel.localTreasury.push(member['defaultEmail']);
              if (this.localTreasuryDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localTreasury = treasuryEmails;
                const control = this.coordianatorLocalForm.controls["localTreasury"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }

            case 'reviewer buManagement': {
              let buEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localBUDefaultMember = [];
              for (let email of buEmails) {
                if (email != '') {
                  this.localBUDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              if (this.localBUDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localTreasury = buEmails;
                const control = this.coordianatorLocalForm.controls["localBU"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }


            case 'reviewer others': {
              let othersEmails = member['defaultEmail'].includes(';') ? member['defaultEmail'].split(';') : [member['defaultEmail']];
              this.localOthersDefaultMember = [];
              for (let email of othersEmails) {
                if (email != '') {
                  this.localOthersDefaultMember.push({
                    defaultEmail: email,
                    reviewerId: member['reviewerId'],
                    type: member['type']
                  })
                }
              }
              //this.coordianatorLocalForm?.controls['localTreasury'].setValue(member['defaultEmail']);
              //this.coordianatorLocalFormModel.localTreasury.push(member['defaultEmail']);
              if (this.localOthersDefaultMember.length > 0) {
                this.coordianatorLocalFormModel.localOthers = othersEmails;
                const control = this.coordianatorLocalForm.controls["localOthers"];
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
              break;
            }
            
          }
        }
      );
    }
  }

  setResetDueDateFormValidation() {
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        const controls = this.coordianatorLocalForm?.controls["dueDate"];
        if (this.isDueDate) {
          controls.removeValidators([Validators.required]);
          controls?.updateValueAndValidity();
        } else {
          controls.setValidators([Validators.required]);
          controls?.updateValueAndValidity({ onlySelf: true });
        }
        //const cocurrenceLocalLegalControl = this.coordianatorLocalForm?.controls["localLegal"];
        //if (this.localLegalFormModel.localLegal.length>0) {
        //  cocurrenceLocalLegalControl.removeValidators([Validators.required]);
        //  cocurrenceLocalLegalControl?.updateValueAndValidity();
        //} else {
        //  cocurrenceLocalLegalControl.setValidators([Validators.required]);
        //  cocurrenceLocalLegalControl?.updateValueAndValidity({ onlySelf: true });
        //}
        break;
      }
      case STATUSPendingIFCConcurrence: {
        const cocurrenceDueDateControl = this.localSecretaryForm?.controls["dueDate"];
        if (this.isDueDate) {
          cocurrenceDueDateControl.removeValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity();
        } else {
          cocurrenceDueDateControl.setValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity({ onlySelf: true });
        }
        //const cocurrenceLocalLegalControl = this.localSecretaryForm?.controls["localLegal"];
        //if (this.localLegalFormModel.localLegal) {
        //  cocurrenceLocalLegalControl.removeValidators([Validators.required]);
        //  cocurrenceLocalLegalControl?.updateValueAndValidity();
        //} else {
        //  cocurrenceLocalLegalControl.setValidators([Validators.required]);
        //  cocurrenceLocalLegalControl?.updateValueAndValidity({ onlySelf: true });
        //}
        break;
      }
      case STATUSPendingLocalIFCConcurrence: {
        const cocurrenceDueDateControl = this.localSecretaryForm?.controls["dueDate"];
        if (this.isDueDate) {
          cocurrenceDueDateControl.removeValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity();
        } else {
          cocurrenceDueDateControl.setValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
    }
  }

  // to get confirmation from modal
  getConfirmation(action: string) {
    this.showHideLIFCModal = false;
    this.setResetToggleValue(action);
    
  }

  // toggle btn to reset the group members
  resetApprovalToggle(event: any, groupName: string) {
    if (event) {
      this.resetGroupName = groupName;
      this.showHideLIFCModal = true;
      this.updateIFCMemberResetValue(groupName, true);
    }
  }

  updateIFCMemberResetValue(group: string, resetAction: boolean) {
    switch (group) {
      case 'localifclegal': {
        this.localLegalForm?.controls['localLegalSwitch'].setValue(resetAction);
        this.localLegalForm?.controls['localLegalSwitch'].disable();
        break;
      }
      case 'localifccontrollers': {
        this.localControllersForm?.controls['localControllersSwitch'].setValue(resetAction);
        this.localControllersForm.controls['localControllersSwitch'].disable();
        break;
      }
      case 'localifctax': {
        this.localTaxForm?.controls['localTaxSwitch'].setValue(resetAction);
        this.localTaxForm?.controls['localTaxSwitch'].disable();
        break;
      }
      case 'localifctreasury': {
        this.localTreasuryForm?.controls['localTreasurySwitch'].setValue(resetAction);
        this.localTreasuryForm?.controls['localTreasurySwitch'].disable();
        break;
      }
      case 'localifcBU': {
        this.localBUForm?.controls['localBUSwitch'].setValue(resetAction);
        this.localBUForm?.controls['localBUSwitch'].disable();
        break;
      }
      case 'localifcOthers': {
        this.localOthersForm?.controls['localOthersSwitch'].setValue(resetAction);
        this.localOthersForm?.controls['localOthersSwitch'].disable();
        break;
      }
      // case 'governance': {
      //   this.localGovernanceForm?.controls['localGovernanceSwitch'].setValue(resetAction);
      //   this.localGovernanceForm?.controls['localGovernanceSwitch'].disable();
      //   break;
      // }
    }
  }

  // based upon modal action status set values into forms fields.
  setResetToggleValue(action: string) {
    this.showHideLIFCModal = false;
    if (action == 'yes') {
      this.isResetEmailTrigger.emit(true);
      this.createPayload();
      switch (this.resetGroupName) {
        case 'localifclegal': {
          this.legalConcurrence = '';
          this.localLegalForm?.controls['localLegal'].enable();
          this.localReviewersService.updateLocalApproval(LOCALLEGAL);
          break;
        }
        case 'localifccontrollers': {
          this.controllersConcurrence = '';
          this.localControllersForm?.controls['localControllers'].enable();
          this.localReviewersService.updateLocalApproval(LOCALCOMPTROLLERS);
          break;
        }
        case 'localifctax': {
          this.taxConcurrence = '';
          this.localTaxForm?.controls['localTax'].enable();
          this.localReviewersService.updateLocalApproval(LOCALTAX);
          break;
        }
        case 'localifctreasury': {
          this.treasuryConcurrence = '';
          this.localTreasuryForm?.controls['localTreasury'].enable();
          this.localReviewersService.updateLocalApproval(LOCALTREASURY);
          break;
        }
        case 'localifcBU': {
          this.buConcurrence = '';
          this.localBUForm?.controls['localifcBU'].enable();
          this.localReviewersService.updateLocalApproval(LOCALBU);
          break;
        }
        case 'localifcOthers': {
          this.othersConcurrence = '';
          this.localOthersForm?.controls['localifcOthers'].enable();
          this.localReviewersService.updateLocalApproval(LOCALOTHERS);
          break;
        }
        
        default: {
          break;
        }
      }
    } else {
      //this.getApprovalsList();
      this.showHideLIFCModal=false;
      //this.enableDisableGroupMemeberField();
    }


  }

  enableDisableGroupMemeberField() {
    switch (this.resetGroupName) {
      case 'localifclegal': {
        this.localLegalForm?.controls['localLegal'].disable();
        break;
      }
      case 'localifccontrollers': {
        this.localControllersForm?.controls['localControllers'].disable();
        break;
      }
      case 'localifctax': {
        this.localTaxForm?.controls['localTax'].disable();
        break;
      }
      case 'localifctreasury': {
        this.localTreasuryForm?.controls['localTreasury'].disable();
        break;
      }
      case 'localifcBU': {
        this.localBUForm?.controls['localBU'].disable();
        break;
      }
      case 'localifcOthers': {
        this.localOthersForm?.controls['localOthers'].disable();
        break;
      }
      // case 'governance': {
      //   this.localGovernanceForm?.controls['localGovernance'].disable();
      //   break;
      // }
    }
  }

  selectDueByDate(event: any) {
    if (!event) {
      this.localReviewersService.getLocalUpdateRecordsStatus(undefined);
      this.session.setItem("duedate", null);
      this.isDueDate = null;
      this.createPayload();
    } else {
      let dueDate = new Date(event).toLocaleString('en-US');
      this.session.setItem("duedate", dueDate);
      this.setResetDueDateFormValidation();
      let isNewDateSelected = this.compareDueDateAndSelectedDate(event);
      if (this.isActionComplete || isNewDateSelected) {
        if (this.isDueDate) {
          this.localReviewersService.getLocalUpdateRecordsStatus(true);
          this.isLocalApprovalSubmitted.emit(true);
          this.isDueDate = dueDate;
          this.isActionComplete = false;
          this.createPayload();
        } else {
          this.localReviewersService.getLocalUpdateRecordsStatus(false);
          this.isLocalApprovalSubmitted.emit(false);
          this.isDueDate = dueDate;
          this.isActionComplete = false;
          this.createPayload();
        }
      }
    }
  }

  compareDueDateAndSelectedDate(event: any) {
    if (this.isDueDate == event) {
      this.localReviewersService.reviewNsubmitStatus(undefined);
      this.localReviewersService.getLocalUpdateRecordsStatus(undefined);
      return false;
    } else {
      this.localReviewersService.reviewNsubmitStatus(true);
      return true;
    }
  }

  selectConcurByDate(event: any) {
    if (event) {
      this.isConcurDate = event;
    }
  }

  legalPayload() {
    const dueDate = this.isDueDate ? this.isDueDate : this.sessionDueDate;
    const legalPayload = [
      {
        reviewerId: 7, //this.localLegalDefaultMember[0]?.reviewerId,
        type: "Reviewer Legal", //this.localLegalDefaultMember[0]?.type,
        approvalsId: Number(this.localLegalApprovalsId),
        approverId: null,
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localLegal'].value?.join(";") : this.localLegalForm?.controls['localLegal'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus === STATUSPendingGovernance ? null : this.legalConcuredStatus,
        comment: this.proposalStatus === STATUSPendingGovernance ? '' : this.localLegalForm?.controls['legalComments'].value,
        reset: this.proposalStatus === STATUSPendingGovernance ? null : this.localLegalForm?.controls['localLegalSwitch'].value,
      }
    ];
    
    return legalPayload;
  }

  createPayload() {
     const dueDate = this.isDueDate;//? this.isDueDate : this.sessionDueDate; 
    let payload: LocalIFCGroupsDTO[] = [
      {
        reviewerId: (this.localControllersDefaultMember && this.localControllersDefaultMember.length > 0) ? this.localControllersDefaultMember[0].reviewerId : 0,
        type: (this.localControllersDefaultMember && this.localControllersDefaultMember.length > 0) ? this.localControllersDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localControllersApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localControllers'].value?.join(";") : this.localControllersForm?.controls['localControllers'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.controllersConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localControllersForm?.controls['controllersComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localControllersForm?.controls['localControllersSwitch'].value,
      },
      {
        reviewerId: (this.localTaxDefaultMember && this.localTaxDefaultMember.length > 0) ? this.localTaxDefaultMember[0].reviewerId : 0,
        type: (this.localTaxDefaultMember && this.localTaxDefaultMember.length > 0) ? this.localTaxDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localTaxApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localTax'].value?.join(";") : this.localTaxForm?.controls['localTax'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.taxConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localTaxForm?.controls['taxComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localTaxForm?.controls['localTaxSwitch'].value,
      },
      {
        reviewerId: (this.localTreasuryDefaultMember && this.localTreasuryDefaultMember.length > 0) ? this.localTreasuryDefaultMember[0].reviewerId : 0,
        type: (this.localTreasuryDefaultMember && this.localTreasuryDefaultMember.length > 0) ? this.localTreasuryDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localTresuryApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localTreasury'].value?.join(";") : this.localTreasuryForm?.controls['localTreasury'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.treasuryConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localTreasuryForm?.controls['treasuryComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localTreasuryForm?.controls['localTreasurySwitch'].value,
      },
      {
        reviewerId: (this.localBUDefaultMember && this.localBUDefaultMember.length > 0) ? this.localBUDefaultMember[0].reviewerId : 0,
        type: (this.localBUDefaultMember && this.localBUDefaultMember.length > 0) ? this.localBUDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localBUApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localBU'].value?.join(";") : this.localBUForm?.controls['localBU'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.buConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localBUForm?.controls['buComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localBUForm?.controls['localBUSwitch'].value,
      },
      {
        reviewerId: (this.localLegalDefaultMember && this.localLegalDefaultMember.length > 0) ? this.localLegalDefaultMember[0].reviewerId : 0,
        type: (this.localLegalDefaultMember && this.localLegalDefaultMember.length > 0) ? this.localLegalDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localLegalApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localLegal'].value?.join(";") : this.localLegalForm?.controls['localLegal'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.legalConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localLegalForm?.controls['legalComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localLegalForm?.controls['localLegalSwitch'].value,
      },
      {
        reviewerId: (this.localOthersDefaultMember && this.localOthersDefaultMember.length > 0) ? this.localOthersDefaultMember[0].reviewerId : 0,
        type: (this.localOthersDefaultMember && this.localOthersDefaultMember.length > 0) ? this.localOthersDefaultMember[0].type : '',
        approverId: null,
        approvalsId: Number(this.localOthersApprovalsId),
        approverEmail: this.proposalStatus === STATUSPendingGovernance ?
          this.coordianatorLocalForm?.controls['localOthers'].value?.join(";") : this.localOthersForm?.controls['localOthers'].value?.join(";"),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus == STATUSPendingGovernance ? null : this.othersConcuredStatus,
        comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.localOthersForm?.controls['othersComments'].value,
        reset: this.proposalStatus == STATUSPendingGovernance ? null : this.localOthersForm?.controls['localOthersSwitch'].value,
      },
      ];
      this.localReviewersService.localReviewersPayload(payload);
      this.localPayloadRecords.emit(payload);
  }

  reviewComponentUIShowHideData(records: LocalIFCGroupsDTO[]) {
    this.approvalsRecords = [...records];
    switch (this.reviewComponent) {
      case true: {
        this.getFullName();
        break;
      }
      case false: {
        break;
      }
      case undefined: {
        break;
      }
    }
  }

  async getFullName() {
    let userFullName: string;
    for (let user of this.approvalsRecords) {
      user.fullName = "";
      for (let userEmail of user.approverEmail.split(';')) {
        this.graph.getUserByEmail(userEmail).subscribe((data: UserDetails) => {
          userFullName = `${data.givenName} ${data.surname}`;
          if (userFullName != undefined)
            user.fullName += userFullName+"  ";
        })
      }
     
    }
  }

  getErrorTipForDueDate(controlName: string): any {
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        const control = this.coordianatorLocalForm?.controls[controlName];
        this.showErrorMsg(control);
        break;
      }
      case STATUSPendingLocalIFCConcurrence: {
        const control = this.localSecretaryForm?.controls[controlName];
        this.showErrorMsg(control);
        break;
      }
    }
  }

  showErrorMsg(control: any) {
    if (control.hasError('required')) {
      return "Please select Due by Date!"
    }
    return ""
  }

  async searchGroupMember(value: string, groupName: string) {
    //this.localLegalDefaultMember = [];
    if (value) {
      let users = [...await this.dataservice.searchUser(value)];
      switch (groupName) {
        case 'localLegal': {
          this.localLegalDefaultMember = [];
          for (let user of users) {
            this.localLegalDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 7,
              type: 'Reviewer Legal'
            })
          }
          break;
        }
        case 'localControllers': {
          this.localControllersDefaultMember = [];
          for (let user of users) {
            this.localControllersDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 10,
              type: "Reviewer Finance"
            })
          }
          break;
        }
        case 'localTax': {
          this.localTaxDefaultMember = [];
          for (let user of users) {
            this.localTaxDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 9,
              type: "Reviewer Tax"
            })
          }
          break;
        }
        case 'localTreasury': {
          this.localTreasuryDefaultMember = [];
          for (let user of users) {
            this.localTreasuryDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 8,
              type: "Reviewer Treasury"
            })
          }
          break;
        }
        case 'localBU': {
          this.localBUDefaultMember = [];
          for (let user of users) {
            this.localBUDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 11,
              type: "Reviewer BUManagement"
            })
          }
          break;
        }
        case 'localOthers': {
          this.localOthersDefaultMember = [];
          for (let user of users) {
            this.localOthersDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 12,
              type: "Reviewer Others"
            })
          }
          break;
        }
        // case 'localGovernance': {
        //   for (let user of users) {
        //     this.localGovernanceDefaultMember.push({
        //       defaultEmail: user?.mail,
        //       reviewerId: 5,
        //       type: "Local Governance"
        //     })
        //   }
        //   break;
        // }
      }
    }
  }

  onGroupMemberChange(event: string) {
    this.createPayload();
  }

  sendReminderEmail() {
    this.isReminderEmailTrigger.emit(true);
  }

  ngOnDestroy() {
    this.localReviewersService.reviewNsubmitStatus(undefined);
    this.localReviewersService.getLocalUpdateRecordsStatus(undefined);
    // Clear stale local reviewer payloads so next proposal starts fresh
    this.localReviewersService.localReviewersPayload([]);

    // Reset all local reviewer forms to prevent stale comments carrying over
    this.localLegalForm?.reset();
    this.localControllersForm?.reset();
    this.localTaxForm?.reset();
    this.localTreasuryForm?.reset();
    this.localBUForm?.reset();
    this.localOthersForm?.reset();
    this.localSecretaryForm?.reset();
    this.coordianatorLocalForm?.reset();

    // Reset form model objects
    this.localLegalFormModel = { localLegal: [], legalComments: '', localLegalSwitch: false };
    this.localControllersFormModel = { localControllers: [], controllersComments: '', localControllersSwitch: false };
    this.localTaxFormModel = { localTax: [], taxComments: '', localTaxSwitch: false };
    this.localTreasuryFormModel = { localTreasury: [], treasuryComments: '', localTreasurySwitch: false };
    this.localBUFormModel = { localBU: [], buComments: '', localBUSwitch: false };
    this.localOthersFormModel = { localOthers: [], othersComments: '', localOthersSwitch: false };
  }

  getErrorTip(formName: string, controlName: string): string {
    switch (formName) {
      case 'localLegalForm': {
        const localLegalcontrol = this.coordianatorLocalForm.controls[controlName];
        if (localLegalcontrol.hasError('required')) {
          return "Please input Reviewer Legal!"
        }
        return "";
      }
      case 'localControllersForm': {
        const localControllerscontrol = this.coordianatorLocalForm.controls[controlName];
        if (localControllerscontrol.hasError('required')) {
          return "Please input localIfc controllers!"
        }
        return "";
      }
      case 'localTaxForm': {
        const localTaxcontrol = this.coordianatorLocalForm.controls[controlName];
        if (localTaxcontrol.hasError('required')) {
          return "Please input reviewer tax!"
        }
        return "";
      }
      case 'localTreasuryForm': {
        const localTreasurycontrol = this.coordianatorLocalForm.controls[controlName];
        if (localTreasurycontrol.hasError('required')) {
          return "Please input reviewer treasury!"
        }
        return "";
      }
      case 'localBUForm': {
        const localBUcontrol = this.coordianatorLocalForm.controls[controlName];
        if (localBUcontrol.hasError('required')) {
          return "Please input reviewer BU Management!"
        }
        return "";
      }
      case 'localOthersForm': {
        const localOtherscontrol = this.coordianatorLocalForm.controls[controlName];
        if (localOtherscontrol.hasError('required')) {
          return "Please input reviewer others!"
        }
        return "";
      }
      default:
        return "";
    }

  }

}
